import script from "./TransferDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferDetails.vue?vue&type=script&setup=true&lang=ts"

import "./TransferDetails.vue?vue&type=style&index=0&id=3aadfb15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aadfb15"]])

export default __exports__